module.exports = __webpack_public_path__ + "img/brasao-teste.5544feb2.png";